var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.value)?_c('b-card',{staticClass:"border-0 rounded-0 text-center text-uppercase font-weight-light p-2",attrs:{"bg-variant":_vm.bgVariant,"text-variant":"white","no-body":""}},[_vm._v(" "+_vm._s(_vm.$t(`page.results.emotionAnalyticsLabels.${_vm.valenceText}`))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }